/**
 * ロールクラス
 */
export class Role {
    static Invalid = "00"; // 無効
    static General = "01"; // 一般
    static Development = "02"; // 開発
    static Operation = "03"; // 運用
    static SystemManager = "99"; // システム管理

    static RoleMap: { [key: string]: { name: string; } } = {
        "00": { name: "無効" },
        "01": { name: "一般" },
        "02": { name: "開発" },
        "03": { name: "運用" },
        "99": { name: "システム管理" }
    };

    // インスタンス変数
    code: string;

    constructor(code: string) {
        this.code = code;
    }

    /**
     * このロールの名前を返却します.
     *
     * @returns ロール名
     */
    getName(): string {
        return Role.RoleMap[this.code]?.name ?? '不明';
    }

    /**
     * このオブジェクトのcodeを返却します.
     *
     * @returns コード
     */
    getCode(): string {
        return this.code;
    }

    /**
     * 開発以上の権限を持つかどうかを返却します.
     *
     * @return 開発以上の権限であればtrue、開発よりも弱い権限であればfalse
     */
    hasDevelopmentHigherAuth(): boolean {
        return this.code === "02" || this.code === "03" || this.code === "99";
    }
}
